export enum DocumentTypeEnum {
  BANK_STATEMENT = 'BANK_STATEMENT',
  PROOF_OF_INCOME = 'PROOF_OF_INCOME',
  PROOF_OF_DEPOSIT = 'PROOF_OF_DEPOSIT',
  OTHER = 'OTHER',
}
